export default {
    defaultOptions: {
        domain: `.${process.env.DOMAIN}`,
        path: '/',
    },
};
